export function Chat (){
    //Chat Movidesk
    const script = document.createElement("script");    
    script.src = "https://chat.movidesk.com/Scripts/chat-widget.min.js";
    script.async = true;

    document.body.appendChild(script);
}